import React from "react";
import {
  AppBar,
  Avatar,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../assets/AppBarLightLogo.svg";
import DarkLogo from "../../assets/AppBarDarkLogo.svg";
import { ColorModeContext } from "../../constants/theme";
import { useSelector } from "react-redux";

function Appbar({ setOpen }) {
  const TabScreen = useMediaQuery("(min-width: 640px)");

  const { mode } = React.useContext(ColorModeContext);
  const { user } = useSelector((state) => state?.auth?.user);

  return (
    <AppBar
      elevation={1}
      position="fixed"
      color="inherit"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <div className="tw-flex-grow tw-flex tw-items-center tw-justify-start tw-space-x-2">
          {!TabScreen && (
            <IconButton onClick={() => setOpen(true)}>
              <MenuIcon />
            </IconButton>
          )}
          <div className="tw-w-min tw-py-1 tw-px-6 ">
            <img
              src={mode === "dark" ? DarkLogo : Logo}
              alt="Complimate logo"
              width={"30px"}
            />
          </div>
        </div>
        <IconButton>
          <Avatar
            sx={{
              backgroundColor: "white",
              color: "#4B4B4B",
              border: "2px solid #4B4B4B",
              width: "30px",
              height: "30px",
            }}
          >
            {user?.email?.slice(0, 1).toUpperCase()}
          </Avatar>
        </IconButton>
        {user?.email && <Typography>{user?.email}</Typography>}
      </Toolbar>
    </AppBar>
  );
}

export default Appbar;
